
import { defineComponent, PropType } from 'vue'

import { Option } from '@/core/types/oktell.types'

export default defineComponent({
    props: {
        value: {
            type: Number,
            default: null,
        },
        options: {
            type: Array as PropType<Option[]>,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const selectOption = (option: Option) => {
            if (props.disabled) return
            emit('update:value', option.id)
            emit('change', option.id)
        }

        const isOptionSelected = (option: Option) => {
            if (!props.value) return false
            return props.value === option.id
        }

        return {
            selectOption,
            isOptionSelected,
        }
    },
})
